import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { CompanyBondModel } from '@data-layer/models/companies';

/**
 * Customs-broker bonds endpoints (#13102). Mirrors the user-side CompanyBondsRepository.get (the
 * continuous-bond catalog) but on the management/customs-broker prefix; the companyId is the reviewed
 * ES owner's company (a broker reviews multiple companies' entries), supplied by the caller via
 * BrokerEsStateService.companyId — never the active broker company.
 */
@Injectable({
  providedIn: 'root',
})
export class BondsCustomsBrokerManagementRepository {
  constructor(private apiService: ApiService) {}

  public getCompanyBonds(companyId: number, isUsed: boolean = false, isShowLoader: boolean = true): Observable<CompanyBondModel[]> {
    return this.apiService.get<CompanyBondModel[]>(
      `${environment.url.prefixCustoms}v2/management/customs-broker/companies/${companyId}/bonds`,
      null,
      { isUsed, isShowLoader },
    );
  }
}
